import React, { Component } from 'react';
import Wrapper from './style';
import { Modal, Button, Input, Icon, message, Spin, Select } from 'antd';
import { ExclamationCircleOutlined, MailOutlined } from '@ant-design/icons';

import { PAGE_DESC } from '../../config/constants';
import { downloadCSV } from '../../common/utils';
import { EXCHANGE_KEY_REFRESH } from '../../config/media';

const { Option } = Select;
class NewToken extends Component {
	constructor(prop) {
		super(prop);
		this.state = {
			data: {},
			isConfirmed: false,
			openConfirm: false,
			curStep: '',
			defaultValue: this.props.isActiveToken ? 'standard' : 'main',
			selectedOption: '',
			KeyWithName: '',
			otpCode: '',
			verificationCode: ''
		};
	}

	componentDidMount() {
		if (this.props.isSaveApiKey) {
			this.setState({ curStep: '2FA-auth' });
			this.handleOtpProceed();
		};
	};

	copy = (e) => {
		const copyText = e.input;
		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand('copy');
		message.success('Copied!');
	};

	handleGenerate = () => {
		this.setState({ openConfirm: true });
	};

	handleConfirm = () => {
		const { selectedOption, KeyWithName, otpCode, verificationCode, defaultValue } = this.state;
		if (this.props.isSaveApiKey) {
			const body = {
				otp_code: otpCode,
				email_code: verificationCode
			}
			this.props.handleGetAuth(body);
		} else {
			const body = {
				name: KeyWithName,
				type: selectedOption || defaultValue,
				otp_code: otpCode,
				email_code: verificationCode
			}
			this.props.addNewToken(body);
		}
	};

	setConfirm = () => {
		this.setState({ isConfirmed: true });
	};

	handleNext = (curStep) => {
		this.setState({ curStep });
	};

	handleChange = (name, value) => {
		this.setState({ [name]: value });
	};

	maxLengthCheck = (object) => {
		if (object.target.value.length > object.target.maxLength) {
			object.target.value = object.target.value.slice(0, object.target.maxLength)
		}
	};

	handleOtpProceed = () => {
		this.props.getVerificationCode();
	};

	handleRedirect = () => {
		this.props.history.push('/mypage/modify-password?isOpenTwoFA=true');
	};

	handleNameProceed = () => {
		if (this.props.isActiveToken) {
			this.handleOtpProceed();
			this.handleNext('2FA-auth');
		} else {
			this.handleNext('generate-key');
		}
	};

	handleOTPBack = () => {
		if (this.props.isSaveApiKey) {
			this.props.handleClose();
		} else if (this.props.isActiveToken) {
			this.handleNext('name-key');
		} else {
			this.handleNext('generate-key');
		}
	};

	handleKeyProceed = () => {
		this.handleOtpProceed();
		this.handleNext('2FA-auth');
	};

	renderSteps = () => {
		const { newToken = {}, isLoading, isActiveToken, onOk, handleClose, user, isOpen2fa, isMainKeyExist } = this.props;
		const { isConfirmed, openConfirm, curStep, selectedOption, defaultValue, KeyWithName, otpCode, verificationCode } = this.state;

		if (isLoading) {
			return (
				<div className='input-wrapper'>
					<Spin />
				</div>
			);
		} else if (isConfirmed) {
			return (
				<div className='input-wrapper'>
					<h3>
						<Icon type='warning' /> Do not share your exchange key
					</h3>
					<p>
						Write your exchange key somewhere safe!The exchange secret key
						will no longer be available once you leave this page.
					</p>
					<p>
						<Button type='primary' onClick={this.downloadCsv}>
							CSV Download
						</Button>
					</p>
					<p>
						<b>Exchange Key:</b>
					</p>
					<p>
						<Input
							ref={(el) => {
								this.apiKey = el;
							}}
							value={newToken.apiKey}
							readOnly
							addonAfter={
								<Icon
									type='copy'
									onClick={() => this.copy(this.apiKey)}
								/>
							}
						/>
					</p>
					<p>
						<b>Exchange Secret key:</b>
					</p>
					<p>
						<Input
							ref={(el) => {
								this.secretKey = el;
							}}
							value={newToken.secret}
							readOnly
							addonAfter={
								<Icon
									type='copy'
									onClick={() => this.copy(this.secretKey)}
								/>
							}
						/>
					</p>
					<p>
						These keys will be used active your exchange and allow your
						exchange to access the HollaEx network and crypto liquidity
						pools.
					</p>
					<Button
						block
						type='primary'
						onClick={() => {
							onOk();
						}}
					>
						Done
					</Button>
				</div>
			);
		} else if (openConfirm) {
			return (
				<div className='input-wrapper warning-wrapper key-confirmation text-center'>
					<div className="flex-content">
						<div>
							<Icon type="exclamation-circle" className="warning-icon" />
						</div>
						<div>
							<p className='sub-header'>
								<b>Generate exchange keys</b>
							</p>
						</div>
					</div>
					<p>Are you sure you want to generate an exchange keys?</p>
					<Button
						block
						type='primary'
						onClick={this.handleConfirm}
					>
						Proceed
					</Button>
				</div>
			);
		} else if (curStep === 'type-key') {
			return (
				<div className='input-wrapper warning-wrapper'>
					<p className='sub-header'>
						<b>Type of key</b>
					</p>
					<div className='sub-header'>Type</div>
					<Select
						defaultValue={defaultValue}
						className="select-wrapper"
						onChange={(val) => this.handleChange('selectedOption', val)}
					>
						<Option value='main'>Main</Option>
						<Option value='standard'>Standard</Option>
					</Select>
					{!isActiveToken && selectedOption === 'standard'
						?
						<div className='general-content'>
							<div className='d-flex'>
								<ExclamationCircleOutlined />
								<div className='bold'>Must generate a main key first</div>
							</div>
							<div className='disable-txt'>You must have a main key first before generating a new standard key.</div>
						</div>
						: null
					}
					{isActiveToken && selectedOption === 'main' && isMainKeyExist
						?
						<div className='general-content'>
							<div className='d-flex'>
								<ExclamationCircleOutlined />
								<div className='bold'>Main key already active</div>
							</div>
							<div className='disable-txt'>You already have an active main key, To generate a new main key you must go back and revoke the currently active exchange key.</div>
							<div className='errText'>Before revoking your exchange key please be aware that it may adversely effect your exchange</div>
						</div>
						: null
					}
					<Button
						block
						type='primary'
						disabled={(!isActiveToken && selectedOption === 'standard') ||
							(isActiveToken && selectedOption === 'main' && isMainKeyExist)}
						onClick={() => this.handleNext('name-key')}
					>
						Proceed
					</Button>
				</div>
			)
		} else if (curStep === 'name-key') {
			return (
				<div className='input-wrapper warning-wrapper'>
					<p className='sub-header'>
						<b>Name the key</b>
					</p>
					<p>Please name your API key and once you’ve generated your key please keep it private.</p>
					<div className='name-input'>
						<div className='sub-header'>Name</div>
						<Input
							placeholder='API key name |'
							onChange={(e) => this.handleChange('KeyWithName', e.target.value)}
						/>
					</div>
					<div className="flex-content">
						<Button
							block
							type='primary'
							onClick={() => this.handleNext('type-key')}
						>
							Back
						</Button>
						<div className="seperator"></div>
						<Button
							block
							type='primary'
							onClick={this.handleNameProceed}
							disabled={!KeyWithName.length}
						>
							Proceed
						</Button>
					</div>
				</div>
			)
		} else if (curStep === 'generate-key') {
			return (
				<div className='input-wrapper warning-wrapper'>
					<div className='general-wrapper'>
						<ExclamationCircleOutlined />
						<div>
							<div className='sub-header'>
								<b>Generate main key</b>
							</div>
							<p>This will be used to access the network. Are you sure you want to generate a main key?</p>
						</div>
					</div>
					<div className="flex-content">
						<Button
							block
							type='primary'
							onClick={() => this.handleNext('name-key')}
						>
							Back
						</Button>
						<div className="seperator"></div>
						<Button
							block
							type='primary'
							onClick={this.handleKeyProceed}
						>
							Proceed
						</Button>
					</div>
				</div>
			)
		} else if (curStep === '2FA-auth') {
			return (
				<div className='input-wrapper warning-wrapper'>
					<div>
						<div className='verification-wrapper'>
							<div className='d-flex'>
								<MailOutlined style={{color:'#fff'}} />
								<p className='sub-header'>
									<b>Input you security codes</b>
								</p>
							</div>
						</div>
						<p>A unique code was sent to your email that is required to finish the process. Please input the code below to proceed.</p>
						<div className='white-text'>Input code</div>
						<Input
							prefix={<MailOutlined style={{color:'#fff'}}/>}
							className='twoFA-input'
							placeholder="Input the code sent to your email"
							onChange={(e) => this.handleChange('verificationCode', e.target.value)}
						/>
						 <div className='white-text'>Enter two-factor authentication (2FA)</div>
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: '#fff' }}
								/>
							}
							type="number"
							className='twoFA-input'
							placeholder="Enter 6-digit code"
							maxLength="6"
							onInput={this.maxLengthCheck}
							onChange={(e) => this.handleChange('otpCode', e.target.value)}
						/>
					</div>
					<div className="flex-content">
						<Button
							block
							type='primary'
							onClick={this.handleOTPBack}
						>
							Back
						</Button>
						<div className="seperator"></div>
						<Button
							block
							type='primary'
							onClick={this.handleConfirm}
							disabled={!otpCode || !verificationCode}
						>
							Proceed
						</Button>
					</div>
				</div>
			)
		} else if ((user && !user.otp_enabled) || isOpen2fa) {
			return (
				<div className='input-wrapper warning-wrapper text-center'>
					<Icon
						type="lock"
						style={{ color: '#fff', fontSize: '60px' }}
					/>
					<p className='sub-header'>
						<b>Turn on two-factor authentication</b>
					</p>
					<p>In order to generate exchange keys you're required to turn on two-factor authentication (2FA).</p>
					<p>Doing so will greatly increase security of your system.</p>
					<div className="flex-content">
						<Button
							block
							type='primary'
							onClick={handleClose}
						>
							Back
						</Button>
						<div className="seperator"></div>
						<Button
							block
							type='primary'
							onClick={this.handleRedirect}
						>
							Visit 2FA page
						</Button>
					</div>
				</div>
			);
		} else {
			return (
				<div className='input-wrapper warning-wrapper text-center'>
					<img src={EXCHANGE_KEY_REFRESH} className="key-refresh-icon" alt="key-refresh" />
					<p className='sub-header'>
						<b>Generate exchange keys</b>
					</p>
					<p>Generating an exchange key is a sensitive action and should be done with care.</p>
					<div className="flex-content">
						<Button
							block
							type='primary'
							onClick={handleClose}
						>
							Back
						</Button>
						<div className="seperator"></div>
						<Button
							block
							type='primary'
							onClick={() => this.handleNext('type-key')}
						>
							I understand. Proceed.
						</Button>
					</div>
				</div>
			);
		}
	};

	downloadCsv = () => {
		const { newToken } = this.props;
		const csv = `Api Key, Secret,
			${newToken.apiKey}, ${newToken.secret}`;
		downloadCSV(csv, 'exchangeKeys');
	};

	render() {
		const { visible, onOk, onCancel } = this.props;
		const { isConfirmed } = this.state;
		return (
			<Modal
				visible={visible}
				title={isConfirmed ? `${PAGE_DESC.newToken.title}` : null}
				footer={null}
				onOk={onOk}
				onCancel={onCancel}
				width={isConfirmed ? '520px' : '420px'}
			>
				<Wrapper>
					<div className='holla-generate-wrapper'>
						{this.renderSteps()}
					</div>
				</Wrapper>
			</Modal>
		);
	}
}

export default NewToken;
